import React, { ReactNode } from 'react';
import './PreviewTable.scss';

export interface ColumnConfig<T> {
  key: keyof T;
  header: string;
  render?: (value: any, record: T) => React.ReactNode;
}

interface PreviewTableProps<T> {
  records: T[];
  columns: ColumnConfig<T>[];
}

const PREVIEW_LIMIT = 5;

const PreviewTable = <T,>({ records, columns }: PreviewTableProps<T>) => {
  const preview: T[] = records.slice(0, PREVIEW_LIMIT);

  return (
    <div className="preview_table_wrapper">
      <div className="preview_table_label">
        Preview ({preview.length} of {records.length} row
        {records.length !== 1 ? 's' : ''})
      </div>
      <div className="preview_table_scroll">
        <table className="preview_table">
          <thead>
            <tr>
              {columns.map((col: ColumnConfig<T>) => (
                <th key={String(col.key)}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {preview.map((record, i) => (
              <tr key={i}>
                {columns.map((col: ColumnConfig<T>) => {
                  const value: T[keyof T] = record[col.key];
                  const display: ReactNode = col.render
                    ? col.render(value, record)
                    : String(value ?? '');

                  return (
                    <td
                      key={String(col.key)}
                      title={typeof display === 'string' ? display : undefined}
                    >
                      {display}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreviewTable;
